module.exports = __webpack_public_path__ + "img/mypath_logo.9ae7ebcd.svg";